module.exports = "<h1 md-dialog-title class=\"primary-color\">hey title</h1>\n<md-dialog-content class=\"accent-color\">\n    hey this is the content of the dialog\n</md-dialog-content>\n<md-dialog-actions>\n    <button md-raised-button color=\"primary\" md-dialog-close>\n        close button\n    </button>  \n</md-dialog-actions>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/templates/dialog.component.html
// module id = 550
// module chunks = 0